// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aHsv","title":"Header_title__3l_0e","side":"Header_side__7T-dM"};